export default __webpack_public_path__ + "static/media/day9.7478486e.png";